import { requestHelpers } from '../../helpers';
import { getActivePromotionDetails } from '../../helpers/promotionHelpers';

const actions = {
    SET_NETWORKS: 'SET_NETWORKS',
    SET_SLOT_DATA: 'SET_SLOT_DATA',
    RESET_SEARCH_INITIAL_VALUES: 'RESET_SEARCH_INITIAL_VALUES',
    SET_SLIDER_DATA: 'SET_SLIDER_DATA',
    GET_ALL_PROFILES: 'GET_ALL_PROFILES',
    SET_ALL_PROFILES: 'SET_ALL_PROFILES',
};

function getProfiles( personId ) {
    return (dispatch) => {

        dispatch( {
            type: actions.GET_ALL_PROFILES,
            isFetching: true,
            isError: false,
        } );

        requestHelpers
            .authenticatedGetRequest( `/profiles/${ personId }` )
            .then( ( response ) =>  {
                dispatch( {
                    type: actions.SET_ALL_PROFILES,
                    profiles: response.data.profiles,
                    isFetching: false,
                    isError: false,
                } )
            } )
            .catch( error => console.log( 'LOG: ERROR',  error))
    }
}

function getSlotData( slotId, networkId, slider = false, addToSliderData = false, sponsorshipType, external ) {
    const type = slider || addToSliderData ? 'SET_SLIDER_DATA' : 'SET_SLOT_DATA';

    return ( dispatch ) => {
        requestHelpers
            .authenticatedGetRequest( `/sponsorship/slot/${ slotId }/data${ external ? '/external' : ''}`, { network_id: networkId, slider, type: sponsorshipType } )
            .then( ( response ) => {
                return dispatch( {
                    type: type,
                    slotData: response.data,
                    slotId
                } );
            } );
    }
}

function resetInitialVales() {
    return ( dispatch ) => {

        return dispatch({
            type: actions.RESET_SEARCH_INITIAL_VALUES,
        });
    }
}

// function clickedAdvert( advertId, slotId ) {
//     return ( dispatch ) => {
//         requestHelpers
//             .authenticatedPostRequest( `/sponsorship/data/${ advertId }/click?slot_id=${ slotId }` )
//             .then( ( response ) => {
//                 console.log( response.url );
//             } );
//     }
// }

// function getNetworks() {
//     return ( dispatch ) => {
//         requestHelpers
//             .authenticatedGetRequest( '/common/networks' )
//             .then( ( response ) => {
//                 dispatch( {
//                     type: actions.SET_NETWORKS,
//                     networks: response.data,
//                 } );
//             } );
//     }
// }

module.exports = {
    actions,
    getSlotData,
    // clickedAdvert,
    // getNetworks,
    resetInitialVales,
    getProfiles
};



// WEBPACK FOOTER //
// src/client/actions/common/common.js